import { ToolResult } from '@procureai/uix/ai';
import { ReactNode } from 'react';

export type ChatToolResultIndicatorProps = {
  message: string;
  children?: ReactNode;
  defaultOpen?: boolean;
  disabled?: boolean;
};

export const ChatToolResultIndicator = ({
  message,
  disabled = true,
  defaultOpen = false,
  children,
}: ChatToolResultIndicatorProps): ReactNode => {
  return <ToolResult label={message} disabled={disabled} defaultOpen={defaultOpen} children={children} />;
};
